import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';

import { SERVER_URL, APP_CLIENT } from '../constants.js';
import { startSession } from './shared utils/session';

function Login(props) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [username, setUsername] = useState('');
  // Off by default: this app holds money, grants and audit logs, and the
  // machine it runs on is often a shared office desktop.
  const [keepSignedIn, setKeepSignedIn] = useState(false);

  const [user, setUser] = useState({
    email: '', 
    password: ''
  });
  
  const handleChange = (event) => {
    setUser({...user, [event.target.name] : event.target.value});
    if (event.target.name === 'email') {
      setUsername(event.target.value);
    }
  }
      
  const login = () => {
    fetch(SERVER_URL + 'api/v1/auth/authenticate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Client': APP_CLIENT },
      body: JSON.stringify(user)
    })
    .then(response => response.json())
    .then(data => {
      if (data.access_token !== undefined && data.role === 'AGENT') {
        // An agency account carries no USER authority, so every screen here
        // would 403. Say so and hand the session straight back.
        fetch(SERVER_URL + 'api/v1/auth/logout', {
          headers: { Authorization: `Bearer ${data.access_token}` },
        }).catch((err) => console.error(err));
        setMessage('This is an agent account. The agent portal is not available yet — this app is for Bliss staff.');
        setIsError(true);
        setOpen(true);
      } else if (data.access_token !== undefined) {
        startSession({
          accessToken: data.access_token,
          refreshToken: data.refresh_token,
          keepSignedIn,
          email: user.email,
          role: data.role,
          grants: data.grants,
        });
        setMessage('Login successful!');
        setIsError(false);
        setOpen(true);
        props.onLoginSuccess({
          email: user.email,
          role: data.role,
          grants: data.grants,
          showFinancials: data.showFinancials === true,
        });
      } else {
        setMessage('Login failed: check your username and password. To reset a forgotten password, contact Alex or another Admin.');
        setIsError(true);
        setOpen(true);
          }
    })
    .catch(err => console.error(err));
  };        
  
  return (
    <div>
      <Stack spacing={2} alignItems="center" mt={2}>
        <TextField name="email" label="Email" onChange={handleChange} />
        <TextField
          type="password"
          name="password"
          label="Password"
          onChange={handleChange}
        />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ maxWidth: 260, textAlign: 'center', mt: -1 }}
        >
          Forgotten your password? There's no automated reset — contact Alex or
          another Admin to have it reset.
        </Typography>
        <FormControlLabel
          sx={{ mt: -1 }}
          control={
            <Checkbox
              size="small"
              checked={keepSignedIn}
              onChange={(e) => setKeepSignedIn(e.target.checked)}
            />
          }
          label={
            <Typography variant="body2">
              Keep me signed in on this device
            </Typography>
          }
        />

        <Button variant="outlined" color="primary" onClick={login}>
          Login
        </Button>
      </Stack>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        message={message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        ContentProps={{
          style: { backgroundColor: isError ? '#f44336' : '#4caf50' },
        }}
      />
    </div>
  );
  }

export default Login;